/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split a calorie target into protein, carb and fat grams.`)
};

const es_macro_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide un objetivo calórico en gramos de proteína, carbohidratos y grasa.`)
};

const de_macro_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile ein Kalorienziel in Gramm Protein, Kohlenhydrate und Fett auf.`)
};

const nl_macro_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdeel een caloriedoel in grammen eiwit, koolhydraten en vet.`)
};

const fr_macro_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répartissez un objectif calorique en grammes de protéines, glucides et lipides.`)
};

const it_macro_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suddividi un obiettivo calorico in grammi di proteine, carboidrati e grassi.`)
};

const pt_br2_macro_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida uma meta calórica em gramas de proteína, carboidrato e gordura.`)
};

const pt_macro_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida um objetivo calórico em gramas de proteína, hidratos e gordura.`)
};

const ja_macro_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カロリー目標をタンパク質・炭水化物・脂質のグラム数に分けます。`)
};

const zh_macro_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将热量目标拆分为蛋白质、碳水和脂肪的克数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_tool_description", locale)
	if (locale === "en") return en_macro_tool_description(inputs)
	if (locale === "es") return es_macro_tool_description(inputs)
	if (locale === "de") return de_macro_tool_description(inputs)
	if (locale === "nl") return nl_macro_tool_description(inputs)
	if (locale === "fr") return fr_macro_tool_description(inputs)
	if (locale === "it") return it_macro_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_macro_tool_description(inputs)
	if (locale === "pt") return pt_macro_tool_description(inputs)
	if (locale === "ja") return ja_macro_tool_description(inputs)
	return zh_macro_tool_description(inputs)
};